import { render, staticRenderFns } from "./MarksByMonthView.vue?vue&type=template&id=31a6c9b6"
import script from "./MarksByMonthView.vue?vue&type=script&lang=js"
export * from "./MarksByMonthView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports